import { render, staticRenderFns } from "./CreateQuiz.vue?vue&type=template&id=705212dc&scoped=true&"
import script from "./CreateQuiz.vue?vue&type=script&lang=js&"
export * from "./CreateQuiz.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuiz.vue?vue&type=style&index=0&id=705212dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705212dc",
  null
  
)

export default component.exports